import React, { useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { IoMdSend } from "react-icons/io";
import "../../../assets/styles/comment.scss";
import { FaSortAmountDown, FaSortAmountUpAlt } from "react-icons/fa";
import { IoIosCloseCircleOutline } from "react-icons/io";
import dummyPro from "../../../assets/images/common/profile-logo.png";
import { useFormik } from "formik";
import {
  createqueries,
  Deletequeries,
  Like_dislike_queries,
  Listqueries,
} from "../../../api/actions/queries";
import { listUserDropdown } from "../../../api/actions/user";
import mentioninputstyle from "../../../assets/styles/mentionsInputStyle";
import { Mention, MentionsInput } from "react-mentions";

import { FaThumbsUp } from "react-icons/fa6";
import toast from "react-hot-toast";
import { Tooltip } from "@mui/material";

const Commentbox = ({ setIsOpen, id }) => {
  const userData = JSON.parse(localStorage.getItem("user_info"));

  const [user, setUser] = useState([]);
  const [update, setUpdate] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [data, setData] = useState([]);
  const [order, setOrder] = useState("desc");
  const newRef = useRef();
  const containerRef = useRef(null);
  const formik = useFormik({
    initialValues: {
      museum_object: id,
      content: "",
      query_mentions: [],
      query_replies: [],
    },
  });

  const commentSubmitHandler = () => {
    setInputValue("");

    createqueries(formik?.values)((res) => {
      if (res?.status) {
        setUpdate(!update);
      } else {
        formik.setErrors({});
      }
      formik?.setValues({
        museum_object: id,
        content: "",
        query_mentions: [],
        query_replies: [],
      });
    });
  };
  const mentionDropDownHandler = (e) => {
    if (!e || !e.id) {
      console.warn("Invalid user mention:", e);
      return;
    }

    const queryList = [...formik?.values?.query_mentions];
    const isAlreadyAdded = queryList.some((mention) => mention.user === e.id);
    if (isAlreadyAdded) {
      console.warn("User already added:", e.id);
      return;
    }
    queryList.push({
      user: e.id,
      name: e?.display,
      mention_index: queryList.length + 1,
    });
    formik?.setValues({
      ...formik?.values,
      query_mentions: queryList,
      content: formik?.values?.content + `{{${e?.display}}}`,
    });
  };

  const commentAddHandler = (e) => {
    const newInputValue = e.target.value;

    setInputValue(newInputValue); // Update input value
    formik?.setValues({
      ...formik?.values,
      content: newInputValue, // Set content in formik
      // query_mentions: updatedMentions, // Update mentions in formik
    });
  };

  const deleteHandler = (deleteId, userid) => {
    if (userid === userData?.id || userData?.is_admin) {
      Deletequeries([deleteId])((response) => {
        if (response?.status) {
          setUpdate(!update);
        }
      });
    }
  };
  useEffect(() => {
    listUserDropdown({ museum_id: userData?.museum })((response) => {
      const noSameUserList = response?.data?.filter((li) => {
        return li?.value !== String(userData?.id);
      });

      const mentionData = noSameUserList.map((li) => ({
        id: li?.value,
        display: li?.label,
        image: li?.thumbnail,
      }));
      setUser(mentionData);
    });
  }, []);

  const listcomment = () => {
    Listqueries({ object_id: id, order: order })((response) => {
      if (response && response.status) {
        setData(response?.data?.results);
      } else {
      }
    });
  };

  const addReplyHandler = (value, id) => {
    if (newRef?.current) {
      newRef?.current?.scrollIntoView({ behavior: "smooth", block: "end" }); // Scroll to the bottom
    }

    const mentionText = `@{{${value}}} `; // Format the mention text
    const mentionData = {
      user: id, // Store the user ID
      name: value, // Store the user name
      mention_index: formik?.values?.query_mentions.length + 1, // Increment mention index
    };

    // Update the mentions array with the new mention data
    const updatedMentions = [...formik?.values?.query_mentions, mentionData];

    // Set the new formik values
    formik?.setValues({
      ...formik?.values,
      query_mentions: updatedMentions, // Update query_mentions
      content: formik?.values?.content + mentionText, // Append the mention text to the content
    });

    // Focus the textarea after updating the content
    const inputElement = containerRef.current.querySelector("textarea");
    if (inputElement) {
      inputElement.focus(); // Focus the textarea
      const textLength = inputElement.value.length;
      inputElement.setSelectionRange(textLength, textLength); // Place the cursor at the end of the input
    }

    // Update the input value with the new content
    setInputValue(formik?.values?.content + mentionText);
  };

  useEffect(() => {
    listcomment();
  }, [update]);

  const likeHandler = (id, rowIndex) => {
    const newRow = [...data];
    newRow[rowIndex] = {
      ...newRow[rowIndex],
      is_liked: !newRow[rowIndex].is_liked,
    };
    setData(newRow);

    Like_dislike_queries({ id: id })((response) => {
      if (!response?.status) {
        setData((prevData) => {
          const revertRow = [...prevData];
          revertRow[rowIndex] = {
            ...revertRow[rowIndex],
            is_liked: !revertRow[rowIndex].is_liked,
          };
          return revertRow;
        });
      }
    });
  };

  const comingSoonHandler = () => {
    toast("Coming soon", {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: "25px",
      },
    });
  };

  return (
    <div
      className="comment-wrapper"
      style={{
        overflow: "auto",
        height: "100vh",
        backgroundColor: "rgb(226 241 255 / 50%)",
        scrollbarWidth: "none",
      }}
    >
      <div className="cmt-header">
        <h4 style={{ marginLeft: "10px" }}>Discussions</h4>
        <div className="icon-div">
          <div className="accordion-icon">
            <Tooltip
              title={order === "asc" ? "Sort Descending" : "Sort Ascending"}
            >
              <span>
                {order === "asc" ? (
                  <FaSortAmountDown
                    size={20}
                    onClick={() => {
                      setOrder(order === "asc" ? "desc" : "asc");
                      setUpdate(!update);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <FaSortAmountUpAlt
                    size={20}
                    onClick={() => {
                      setOrder(order === "asc" ? "desc" : "asc");
                      setUpdate(!update);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </span>
            </Tooltip>
          </div>
          <div className="accordion-icon">
            <IoIosCloseCircleOutline
              className="comment_clossing"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setUpdate(!update);
                setIsOpen(false);
              }}
              size={25}
            />
          </div>
        </div>
      </div>
      <Form>
        <Container>
          <div ref={newRef} className="accordion-box">
            <Row>
              <div
                className="comment-field"
                style={{ marginTop: "17px", backgroundColor: "transparent" }}
              >
                <img
                  src={userData.thumbnail || dummyPro}
                  style={{
                    filter: userData.thumbnail ? "none" : "grayscale(100%)",
                  }}
                  className="img_profile"
                  height={50}
                  width={50}
                  alt="pro-pic"
                />
                <div className="comment-desc">
                  <Form.Group>
                    <div ref={containerRef}>
                      <MentionsInput
                        style={mentioninputstyle}
                        a11ySuggestionsListLabel={"Suggested mentions"}
                        onChange={commentAddHandler} // Handle input changes
                        value={inputValue} // Bind input value to state
                        rows={3}
                        placeholder="Add a comment. @ to mention a person"
                      >
                        <Mention
                          style={mentioninputstyle}
                          trigger="@" // Trigger for mentions
                          markup="@{{__display__}}" // Markup format for mentions
                          onAdd={(id, display) => {
                            const selectedUser = user.find(
                              (user) => user.id === id
                            );

                            if (selectedUser) {
                              mentionDropDownHandler(selectedUser); // Handle selection of user
                            }
                          }}
                          displayTransform={(id, display) => `@${display}`} // Display the mention with "@"
                          data={user} // Users data for mentions
                          renderSuggestion={(suggestion, focused) => {
                            const isHighlighted = focused
                              ? { backgroundColor: "transparent" }
                              : {};

                            return (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "5px",
                                  ...isHighlighted,
                                }}
                              >
                                <img
                                  src={
                                    suggestion?.image
                                      ? suggestion?.image
                                      : dummyPro
                                  }
                                  alt={suggestion.display}
                                  style={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: "50%",
                                    marginRight: 10,
                                  }}
                                />
                                <span>{suggestion.display}</span>
                              </div>
                            );
                          }}
                        />
                      </MentionsInput>
                    </div>
                    <button type="button" onClick={commentSubmitHandler}>
                      Send <IoMdSend />
                    </button>
                  </Form.Group>
                </div>
              </div>
            </Row>

            <Row className="comment-list-row">
              {data.map((li, indexof) => (
                <div style={{ backgroundColor: "transparent" }}>
                  <Form.Group>
                    <div
                      className="comment-list-box"
                      style={{ backgroundColor: "transparent" }}
                    >
                      <img
                        src={li.created_by_thumbnail || dummyPro}
                        style={{
                          filter: li.created_by_thumbnail
                            ? "none"
                            : "grayscale(100%)",
                        }}
                        className="img_profile"
                        height={50}
                        width={50}
                        alt="pro-pic"
                      />
                      <div
                        className="comment-list-content"
                        style={{
                          backgroundColor: "white",
                          padding: "10px",
                          minWidth: "424px",
                        }}
                      >
                        <div className="comment-header">
                          <div className="header-title">
                            <h6>{li?.created_by_name}</h6>
                            {/* <p>Conservation team</p> */}
                          </div>
                          <p style={{}}>{li?.created_date}</p>
                        </div>
                        <div className="comment-content">
                          <p className="contentspan" style={{ color: "black" }}>
                            {" "}
                            {li?.content
                              ?.split(/(@\{\{.*?\}\})/g) // Split into parts using the mention pattern
                              .filter((part) => part) // Remove empty parts
                              .map((part, index) => {
                                if (/^@\{\{.*?\}\}$/.test(part)) {
                                  // Match only the mentions
                                  const mentionName =
                                    part.match(/@\{\{(.*?)\}\}/)[1]; // Extract the name
                                  return (
                                    <span
                                      key={index}
                                      className="contentspan"
                                      style={{
                                        color: "blue",
                                        wordbreak: "break-all",
                                      }}
                                    >
                                      @{mentionName}
                                    </span>
                                  );
                                }
                                console.log(li, "like");

                                return (
                                  <span
                                    key={index}
                                    className="contentspan"
                                    style={{
                                      color: "black",
                                      wordbreak: "break-all",
                                    }}
                                  >
                                    {part}
                                  </span>
                                ); // Non-mention parts are rendered normally
                              })}
                          </p>
                        </div>
                        <div className="comment-footer">
                          <button className="replay_button" type="button">
                            <p
                              className="p_hover"
                              onClick={() =>
                                addReplyHandler(
                                  li?.created_by_name,
                                  li?.created_by
                                )
                              }
                            >
                              Reply
                            </p>
                          </button>
                          {(li?.created_by === userData?.id ||
                            userData?.is_admin) && (
                            <p
                              className="p_hover"
                              onClick={() =>
                                deleteHandler(li?.id, li?.created_by)
                              }
                            >
                              Delete
                            </p>
                          )}

                          <FaThumbsUp
                            onClick={() => likeHandler(li.id, indexof)}
                            size={50}
                            style={{ color: li.is_liked ? "#20409A" : "" }}
                            className="like_button"
                          />
                        </div>
                      </div>
                    </div>
                  </Form.Group>
                </div>
              ))}
            </Row>
          </div>
        </Container>
      </Form>
    </div>
  );
};

export default Commentbox;
